import React from 'react'
import { useState, useEffect } from 'react';
import ReactQuill from "react-quill";

import "react-quill/dist/quill.snow.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import apiUrl from '../../environment/Api';
import { Link, useNavigate } from "react-router-dom";

const modules = {
    toolbar: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video"],
        ["clean"],
    ],
};

const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
    "background",
    "align",
];

function Addjobportal() {

    const navigate = useNavigate();
    const [addData, setAddData] = useState({
        companyname: '',
        designation: '',
        location: '',
        no_of_vacancies: '',
        applied_candidate: '',
        Job_description: '', // This will store the editor content
        deadline: '',
        start_date: '',
        status: '',
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    // Update the handler to directly set Job_description in addData
    const handleEditorChange = (content) => {
        setAddData({ ...addData, Job_description: content });
    };

    const handlesubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = {
                companyname: addData.companyname,
                designation: addData.designation,
                location: addData.location,
                no_of_vacancies: addData.no_of_vacancies,
                applied_candidate: addData.applied_candidate,
                Job_description: addData.Job_description, // Now this contains the editor content
                deadline: addData.deadline,
                start_date: addData.start_date,
                status: addData.status,
            }

            // Form validation before submission
            if (!addData.companyname || !addData.designation || !addData.Job_description) {
                toast.error("Please fill all required fields!");
                return;
            }

            const response = await axios.post(apiUrl + "/jobportal", formData);
            console.log("Job posting added:", response);
            navigate('/jobportal'); 
            toast.success("Job posting added successfully!");

            // Reset form after successful submission
            setAddData({
                companyname: '',
                designation: '',
                location: '',
                no_of_vacancies: '',
                applied_candidate: '',
                Job_description: '',
                deadline: '',
                start_date: '',
                status: '',
            });
        } catch (error) {
            console.error("Error submitting data:", error.message);
            toast.error("Failed to add job posting. Please try again.");
        }
    };

    return (
        <>

            <div className="" style={{ marginTop: '-80px' }}>
                <div className="row mb-3">
                    <div className="col-lg-11">
                        <Link to="/dashboard" className="text-secondary dashBoard_text">
                            <b>Dashboard / </b>
                        </Link>
                        <Link to="/Jobportal" className="text-secondary dashBoard_text">
                            <b>JobPortal / </b>
                        </Link>
                        <Link to="" className="text-danger dashBoard_text">
                            <b>AddJobPortal</b>
                        </Link>
                        {/* <Link to="" className="text-danger dashBoard_text">
                                    <b>Profile</b>
                                </Link> */}
                    </div>
                </div>
            </div>
            <h1>Job Portal</h1>
            <form onSubmit={handlesubmit}>
                <div className='row mt-3'>
                    <div className='col-lg-6'>
                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                placeholder=''
                                value={addData.companyname}
                                onChange={(e) => setAddData({ ...addData, companyname: e.target.value })}
                                required
                            />
                            <label className={addData.companyname ? "filled" : ""}>
                                Company Name
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                placeholder=''
                                value={addData.designation}
                                onChange={(e) => setAddData({ ...addData, designation: e.target.value })}
                                required
                            />
                            <label className={addData.designation ? "filled" : ""}>
                                Designation
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                placeholder=''
                                value={addData.location}
                                onChange={(e) => setAddData({ ...addData, location: e.target.value })}
                                required
                            />
                            <label className={addData.location ? "filled" : ""}>
                                Location
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                placeholder=''
                                value={addData.no_of_vacancies}
                                onChange={(e) => setAddData({ ...addData, no_of_vacancies: e.target.value })}
                                required
                            />
                            <label className={addData.no_of_vacancies ? "filled" : ""}>
                                Vacancy
                            </label>
                        </div>
                    </div>

                    <div className='col-lg-6'>
                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                placeholder=''
                                value={addData.applied_candidate}
                                onChange={(e) => setAddData({ ...addData, applied_candidate: e.target.value })}
                                required
                            />
                            <label className={addData.applied_candidate ? "filled" : ""}>
                                Applied Candidate
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="date"
                                placeholder=''
                                value={addData.deadline}
                                onChange={(e) => setAddData({ ...addData, deadline: e.target.value })}
                                required
                            />
                            <label className={addData.deadline ? "filled" : ""}>
                                Deadline
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="date"
                                placeholder=''
                                value={addData.start_date}
                                onChange={(e) => setAddData({ ...addData, start_date: e.target.value })}
                                required
                            />
                            <label className={addData.start_date ? "filled" : ""}>
                                Post Date
                            </label>
                        </div>

                        <div className="floating-label">
                            <select
                                className="form-control"
                                value={addData.status || ""}
                                onChange={(e) => setAddData({ ...addData, status: e.target.value })}
                                required
                            >
                                <option value="">Select status</option>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                            </select>
                            <label className={addData.status ? "filled" : ""}>
                                Select status
                            </label>
                        </div>
                    </div>
                </div>

                <div className="mt-4">
                    <h2>Job Description</h2>
                    <ReactQuill
                        theme="snow"
                        value={addData.Job_description}
                        onChange={handleEditorChange}
                        modules={modules}
                        formats={formats}
                        placeholder="Write something amazing..."
                    />
                </div>

                <h3>Editor Output :</h3>
                <div
                    dangerouslySetInnerHTML={{ __html: addData.Job_description }}
                    // style={{ width: "100px", height: "10px" }}
                />


                <div className="mt-4 mb-5">
                    <button type="submit" className="btn btn-danger">
                        Submit
                    </button>
                </div>
            </form >
        </>
    )
}

export default Addjobportal